module.exports = __webpack_public_path__ + "static/media/agent.e8329900.jpg";